export const CARD_HEIGHT_XS = 148;
export const CARD_HEIGHT_SM = 284;
